
<template>
    <div id="app">
    <main>
        <div class="main-center">
            <el-row class="user-author">
                <el-col :span="24">
                    <div class="tcl-logo">
                        <img src="@/assets/logo_tcl.png" alt="logo">
                    </div>
                    <div class="allow-prompt"> {{ $t("alexa.grant_hint") }} </div>
                    <el-button id="grant" type="primary" @click="handleGrant">{{ $t("alexa.grant_allow") }}</el-button>
                </el-col>
            </el-row>
        </div>
    </main>
    </div>
</template>

<script>

import { Config } from '@/config/config';
import { ERR_TO_AMAZON, ERR_AUTHOR_GETCODE } from '@/const/consts';
import { getToken, load } from '@/utils/storage';
import { getOACode } from '@/api/oauth';

import { Message } from 'element-ui';
import queryString from 'query-string';
import 'whatwg-fetch';

const cfg = Config

export default {
    name: 'Grant',
    data: function () {
        return {}
    },
    methods: {
        handleGrant() {
            let token = getToken()
            if (token && token.length > 0) {
                getOACode(token).then(resp => {
                    if (resp.data.code == ERR_AUTHOR_GETCODE && resp.data.Data.length > 0) {
                        const params = this.loadStorage()
                        console.log(params)
                        if (!params.client_id || !params.response_type || !params.scope || !params.state || !params.token) {
                            Message.warning({message: this.$t("alexa.active_code_message_exception")})
                            this.reactive()
                        } else {
                             console.log("====================success")
                        }
                        var redirect_uri = load("redirect_uri") + "?" + queryString.stringify(params) + "&code=" + resp.data.Data
                        console.log(redirect_uri)
                        window.location.href = redirect_uri
                    } else {
                        console.log(resp)
                        this.reactive()
                    }
                }).catch(error => {
                    console.log(error)
                    Message.warning({message: this.$t("alexa.active_code_message_exception")})
                })
            }
            else {
                this.reactive()
            }
        },

        reactive() {
            this.$router.replace({ path: '/active' });
            Message.error({message: this.$t("alexa.grant_message_fail")})
        },

        loadStorage() {
            return {
                client_id: load("client_id"),
                response_type: load("response_type"),
                scope: load("scope"),
                state: load("state"),
                token: load("token")
            }
        },

        setFocus() {
            document.getElementById('grant').focus()
        }
    },

    mounted() {
        this.setFocus();
    }
}

</script>



// WEBPACK FOOTER //
// src/pages/Grant.vue